import { useState } from 'react';
import { WbGrid, WbGridCol, WbGridRow } from '@workbench/react';
import { useTranslation } from 'react-i18next';

import VimdtInput from '../Common/VimdtInput';
import VimdtSwitch from '../Common/VimdtSwitch';
import VimdtButton from '../Common/VimdtButton';
import VimdtAccordion from '../Common/VimdtAccordion';
import './JsonWithSearchAndSave.scss';

/**
 * Search/null-filter header plus a controlled accordion of JSON sections.
 */
function JsonWithSearchAndSave({ title, save, items, collapse, filterInput, nullFilter }) {
	const { t } = useTranslation();
	const [panels, setPanels] = collapse || [];
	const [filterValue, setFilterValue] = filterInput;
	const [, setNullFilter] = nullFilter;
	const [filterPanels, setFilterPanels] = useState([]);

	const filterContent = (
		<WbGrid fullWidth className="vimdt-json-search__filter">
			<WbGridRow>
				<WbGridCol mq1={12} mq3={6}>
					<VimdtInput
						label={t('vimdt.filter.searchEntry')}
						val={filterValue}
						getValue={setFilterValue}
						testId="json-search-input"
					/>
				</WbGridCol>
				<WbGridCol mq1={12} mq3={6}>
					<VimdtSwitch
						label={t('vimdt.filter.hideNull')}
						onBtn={t('vimdt.components.onButton')}
						offBtn={t('vimdt.components.offButton')}
						status={[t('vimdt.components.onButton'), t('vimdt.components.offButton')]}
						defaultValue={false}
						getValue={setNullFilter}
					/>
				</WbGridCol>
			</WbGridRow>
		</WbGrid>
	);

	return (
		<div className="vimdt-json-search">
			{save && (
				<div className="vimdt-json-search__save">
					<VimdtButton
						label={t('vimdt.loadSaveButtons.saveData')}
						filledIn={false}
						onClick={save}
					/>
				</div>
			)}

			<VimdtAccordion
				activeKeys={filterPanels}
				onChange={setFilterPanels}
				items={[{ key: 'filter', header: title, content: filterContent }]}
			/>

			<VimdtAccordion items={items} activeKeys={panels} onChange={setPanels} />
		</div>
	);
}

export default JsonWithSearchAndSave;
